export default __webpack_public_path__ + "static/media/rnr-sports-table-12-cn.2d7f29c9.webp";